var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContractors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 68,
    viewBox: "0 0 66 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 34.25H12V38.75H27.75V34.25Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 23H12V27.5H39V23Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 11.75H12V16.25H39V11.75Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.92 63.5H5.25C2.76 63.5 0.75 61.49 0.75 59V5C0.75 2.51 2.76 0.5 5.25 0.5H45.75C48.24 0.5 50.25 2.51 50.25 5V18.77H45.75V5H5.25V59H16.92V63.5Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.95 31.46L57.54 24.05C56.88 23.39 55.95 23 55.02 23C54.09 23 53.16 23.36 52.5 24.05L21 55.55V68H33.45L64.95 36.5C65.61 35.84 66 34.91 66 33.98C66 33.05 65.64 32.12 64.95 31.46ZM31.59 63.5H25.5V57.41L46.74 36.17L52.83 42.26L31.59 63.5ZM56.01 39.08L49.92 32.99L55.02 27.89L61.11 33.98L56.01 39.08Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContractors);
export default __webpack_public_path__ + "static/media/ic-contractors.19ccd70156ae9bd0579e3c657f417d0f.svg";
export { ForwardRef as ReactComponent };